const styles = {
  srcAddressWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    position: "relative",
    p: {
      xs: "10px 16px 0",
      md: "10px 36px 0",
    },
  },
  srcBuildWrap: {
    display: "flex",
    gap: "20px",
  },
  progress: {
    position: "absolute",
    right: "10px",
    top: "17px",
    color: "text.secondary",
  },
};

export default styles;
